module.exports = false;



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_library.js
// module id = 575
// module chunks = 25